import { useCallback } from "react";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";
import { CalcelSimulationRequest, RunSimulationRequest, RiverAndRainSensorID,InsertPastRainDataRequest } from "../types/type";

let client = axios.create({
  baseURL: process.env.REACT_APP_API_URL ?? "http://localhost:8000",
  headers: {
    "Content-Type": "application/json",
  },
  responseType: "json",
});

// function sleepByPromise(sec: number) {
//   return new Promise(resolve => setTimeout(resolve, sec * 1000));
// }

// const handleError = (error: any) => {
//   alert("サーバエラー:操作を完了できませんでした。開発元にお問い合わせください。\n");
// }

export function useAuth0Token() {
  const { getAccessTokenSilently, getIdTokenClaims } = useAuth0();
  const getToken = useCallback(async () => {
    if (process.env.REACT_APP_AUTH0_DOMAIN) {
      await getAccessTokenSilently();
      const idToken = await getIdTokenClaims();
      return idToken?.__raw;
    } else {
      return undefined;
    }
  }, [getAccessTokenSilently, getIdTokenClaims]);
  return { getToken };
}

export const getSimulations = async (idToken: string | undefined) => {
  const httpConfig = idToken
    ? { headers: { Authorization: `Bearer ${idToken}` } }
    : {};
  try {
    const httpData = await client.get<any>(
      "/v1/simulations",
      // "/v1/get_simulation_list",
      httpConfig
    );
    return httpData.data;
  } catch (e: any) {
    throw e;
  }
};

export const getSimulationInputs = async (
  idToken: string | undefined,
  id: string
) => {
  const httpConfig = idToken
    ? { headers: { Authorization: `Bearer ${idToken}` } }
    : {};
  try {
    const httpData = await client.get<any>(
      `/v1/simulations/${id}/inputs`,
      // `/v1/get_rainfall?simu_id=${id}`,
      httpConfig
    );
    return httpData.data;
  } catch (e: any) {
    throw e;
  }
};

export const runSimulation = async (
  idToken: string | undefined,
  params: RunSimulationRequest
) => {
  const httpConfig = idToken
    ? { headers: { Authorization: `Bearer ${idToken}` } }
    : {};
  try {
    const httpData = await client.post<any>(
      "/v1/simulations",
      // "/v1/post_run_simulation",
      params,
      httpConfig
    );
    return httpData.data;
  } catch (e: any) {
    throw e;
  }
};

export const cancelSimulation = async (
  idToken: string | undefined,
  params: CalcelSimulationRequest
) => {
  const httpConfig = idToken
    ? { headers: { Authorization: `Bearer ${idToken}` } }
    : {};
  try {
    const httpData = await client.put<any>(
      `/v1/simulations/${params.simu_id}`,
      // "/v1/post_cancel_simulation",
      {},
      httpConfig
    );
    return httpData.data;
  } catch (e: any) {
    throw e;
  }
};

export const getSimulationResults = async (
  idToken: string | undefined,
  id: string
) => {
  const httpConfig = idToken
    ? { headers: { Authorization: `Bearer ${idToken}` } }
    : {};
  try {
    const httpData = await client.get<any>(
      `/v1/simulations/${id}/results`,
      httpConfig
    );
    return httpData.data;
  } catch (e: any) {
    throw e;
  }
};

export const getRiverLevelAndRainfall = async (
  idToken: string | undefined,
  params: RiverAndRainSensorID
) => {
  const httpConfig = idToken
    ? { headers: { Authorization: `Bearer ${idToken}` }, params: params }
    : {params: params};
  try {
    const httpData = await client.get<any>(
      `/v1/parameters`,
      // `/v1/get_riverlevel_and_rainfall`,
      httpConfig
    );
    return httpData.data;
  } catch (e: any) {
    throw e;
  }
};

export const insertPastRainData = async (
  idToken: string | undefined,
  params: InsertPastRainDataRequest
) => {
  const httpConfig = idToken
    ? { headers: { Authorization: `Bearer ${idToken}` } }
    : {};
  try {
    const httpData = await client.post<any>(
      "/v1/parameters",
      // "/v1/post_insert_pastrainfall_from_front",
      params,
      httpConfig
    );
    return httpData.data;
  } catch (e: any) {
    throw e;
  }
};
